import { getAsync } from "./_base"

const serviceApiUrl = import.meta.env.VITE_APP_API_SERVICE_URL;

export const getServiceAsync = (postcode: string, serviceId: number) => {
  return getAsync(serviceApiUrl + '/' + serviceId, { postcode });
}